import * as React from 'react'
import { connect } from 'react-redux'
import { noop } from 'lodash'
import { RouteComponentProps } from 'react-router-dom'

import NavBar from '@doordash/component-navbar'
import { Text, Colors, Inset, StackChildren } from '@doordash/design-language'

import { getDasherCountry } from '../../../../selectors/deliveryIssues'
import { loadUrl } from '../../../../webview'
import ListCellMenuItem from '../components/ListCellMenuItem'
import { getDeactivationPolicyUrl } from '../utilities'
import {
  IC_AGREEMENT_URL,
  CRITICAL_DELIVERY_ISSUES_FAQ_URL,
  EXTREME_LATENESS_FAQ_URL,
  CUSTOMER_IS_UNAVAILABLE_FAQ_URL,
} from '../constants'
import { DasherCountries } from '../types'
import t from './strings'
import { NavBarHeaderTitle } from '../components/styles'
import ListCell from '@doordash/component-list-cell'
import { PolicyViolation, EventActions } from '../../../../typeModules/events'
import * as events from '../../../../events'
import { PolicyViolationPages } from '../../../../models/types'

type ExplanationProps = {
  country: DasherCountries
  track: (data: PolicyViolation) => Promise<any>
}
enum LearnMoreLinkName {
  ICAgreement = 'ic_agreement',
  DeactivationPolicy = 'deactivation_policy',
  CustomerUnavailableFaq = 'customer_unavailable',
  NeverArrivedFaq = 'never_arrived_faq',
  ExtremeLatenessFaq = 'extreme_lateness_faq',
}

const listCellStyleProps = {
  separatorType: ListCell.SeparatorTypes.InsetBorder,
}

const LinkDictionary = {
  [LearnMoreLinkName.ICAgreement]: {
    title: t.icAgreement(),
    link: () => IC_AGREEMENT_URL,
  },
  [LearnMoreLinkName.DeactivationPolicy]: {
    title: t.deactivationPolicy(),
    link: country => getDeactivationPolicyUrl(country),
  },
  [LearnMoreLinkName.CustomerUnavailableFaq]: {
    title: t.customerUnavailableFaq(),
    link: () => CUSTOMER_IS_UNAVAILABLE_FAQ_URL,
  },
  [LearnMoreLinkName.NeverArrivedFaq]: {
    title: t.deactivationPolicy(),
    link: () => CRITICAL_DELIVERY_ISSUES_FAQ_URL,
  },
  [LearnMoreLinkName.ExtremeLatenessFaq]: {
    title: t.extremeLatenessFaq(),
    link: () => EXTREME_LATENESS_FAQ_URL,
  },
}

const Explanation: React.FC<RouteComponentProps & ExplanationProps> = ({
  history,
  country,
  track,
}) => {
  React.useEffect(() => {
    track({
      page: PolicyViolationPages.LearnMore,
      action: EventActions.Rendered,
    })
  }, [track])

  return (
    <div>
      <NavBar
        isSeparatorVisible={false}
        navigationType={NavBar.NavigationTypes.Back}
        onNavigationClick={() => history.goBack()}
        onOverflowClick={noop}
      />
      <NavBarHeaderTitle>
        <Text styles={Text.Styles.Bold24}>{t.title()}</Text>
      </NavBarHeaderTitle>
      <Inset>
        <StackChildren>
          <Text
            styles={Text.Styles.PageDescriptionBody}
            color={Colors.SystemGrey60}
          >
            {t.body()}
          </Text>
        </StackChildren>
      </Inset>
      <div role="list">
        {Object.values(LearnMoreLinkName).map(key => (
          <ListCellMenuItem
            title={LinkDictionary[key].title}
            onClick={() => {
              track({
                page: PolicyViolationPages.LearnMore,
                action: EventActions.Clicked,
                data: {
                  name: key,
                },
              })
              return loadUrl(LinkDictionary[key].link(country))
            }}
            {...listCellStyleProps}
          />
        ))}
      </div>
    </div>
  )
}

const mapStateToProps = state => ({
  country: getDasherCountry(state),
})

const mapDispatchToProps = {
  track: events.trackPolicyViolations,
}

export const DisconnectedExplanation = Explanation
export default connect(mapStateToProps, mapDispatchToProps)(Explanation)
